module.exports = __webpack_public_path__ + "static/HERO_FF-079b6094fc0947b9c53e64909e5b1599.png";